module.exports = __webpack_public_path__ + "media/images/pic/timeline/2016-6302424d3b597cbe33a6be1768eaf3d3.jpg";